import { render, staticRenderFns } from "./CarTypeSale.vue?vue&type=template&id=16f2803f"
import script from "./CarTypeSale.vue?vue&type=script&lang=js"
export * from "./CarTypeSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports